import { InitialStateMinimumRequirements_StaticMedia } from "./initial-state-requirements";

export const staticMediaUrl = (
  initialState: InitialStateMinimumRequirements_StaticMedia,
  myMediaPath: string
) => {
  const { view_file_url } = initialState;
  return `${view_file_url || ""}/${myMediaPath}`;
};
